import { Component } from '@angular/core';

@Component({
  selector: 'app-centers',
  standalone: true,
  imports: [],
  templateUrl: './centers.component.html',
  styleUrl: './centers.component.css'
})
export class CentersComponent {

}
